module.exports = __webpack_public_path__ + "static/media/cy.10284c68.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/cy.png
// module id = 1829
// module chunks = 0